import PropTypes from 'prop-types';

// material-ui
import { Autocomplete as MuiAutocomplete, TextField, Box } from '@mui/material';

// third-party
import { useIntl } from 'react-intl';

// ==============================|| APP AUTOCOMPLETE ||============================== //

const Autocomplete = ({
    id,
    value,
    inputValue,
    onChange,
    onInputChange,
    freeSolo,
    multiple,
    loading,
    disabled,
    options = [],
    limitTags = 5,
    getOptionLabel,
    renderOption,
    renderInput,
    filterOptions,
    errorMsg,
    // PopperComponent,
    disablePortal,
    onClose,
    ...others
}) => {
    const intl = useIntl();

    return (
        <MuiAutocomplete
            id={id}
            value={multiple ? [].concat(value).filter(Boolean) : value}
            inputValue={inputValue}
            onChange={(event, value, reason) => {
                if (typeof onChange === 'function') {
                    onChange(value, reason);
                }
            }}
            onInputChange={(event, value, reason) => {
                if (typeof onInputChange === 'function') {
                    onInputChange(value, reason);
                }
            }}
            freeSolo={Boolean(freeSolo)}
            multiple={Boolean(multiple)}
            loading={Boolean(loading)}
            disabled={Boolean(disabled)}
            options={options}
            selectOnFocus
            clearOnBlur
            clearOnEscape
            handleHomeEndKeys
            fullWidth
            autoHighlight
            filterSelectedOptions
            limitTags={limitTags}
            getOptionLabel={(option) => {
                if (!option) return '';
                if (typeof getOptionLabel === 'function') {
                    return getOptionLabel(option);
                }

                return option;
            }}
            renderOption={(props, option, ...others) => {
                if (!option) return <Box component="li" {...props} />;
                if (typeof renderOption === 'function') {
                    return renderOption(props, option, ...others);
                }

                return (
                    <Box component="li" {...props}>
                        {option}
                    </Box>
                );
            }}
            renderInput={(params) => {
                if (typeof renderInput === 'function') {
                    return renderInput(params);
                }

                return (
                    <TextField
                        {...params}
                        inputProps={{ ...params.inputProps }}
                        error={Boolean(errorMsg)}
                        helperText={Boolean(errorMsg) && errorMsg}
                    />
                );
            }}
            filterOptions={(options, params) => {
                if (typeof filterOptions === 'function') {
                    return filterOptions(options, params);
                }

                return options;
            }}
            clearText={intl.formatMessage({ id: 'ui-comp-button-clearfield' })}
            loadingText={intl.formatMessage({ id: 'ui-comp-autocomplete-loading' })}
            noOptionsText={intl.formatMessage({ id: 'ui-comp-autocomplete-nooptions' })}
            // PopperComponent={PopperComponent}
            disablePortal={disablePortal}
            onClose={onClose}
            {...others}
        />
    );
};

Autocomplete.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.any,
    inputValue: PropTypes.any,
    onChange: PropTypes.func,
    onInputChange: PropTypes.func,
    freeSolo: PropTypes.bool,
    multiple: PropTypes.bool,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    options: PropTypes.array,
    limitTags: PropTypes.number,
    getOptionLabel: PropTypes.func,
    renderOption: PropTypes.func,
    renderInput: PropTypes.func,
    filterOptions: PropTypes.func,
    // PopperComponent: PropTypes.any,
    disablePortal: PropTypes.bool,
    onClose: PropTypes.func,
    errorMsg: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object])
};

export default Autocomplete;
